/* Papeterie Montparnasse — Cart drawer : glissement fluide + voile + verrou de défilement.
   ADDITIF & RÉVERSIBLE. Ne remplace PAS la logique panier native : on observe seulement
   l'attribut [open] posé par <cart-drawer> et on l'accompagne (voile de fond, scroll-lock,
   fermeture par clic voile / touche Échap). Le glissement lui-même est en CSS (pm-identity.css). */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var cd = document.getElementById('cart-drawer');
    if (!cd) return;

    var overlay = null;

    function makeOverlay() {
      if (overlay) return overlay;
      overlay = document.createElement('div');
      overlay.className = 'pm-drawer-overlay';
      // Le voile se place juste avant le drawer pour rester sous lui (z-index 998 < 999).
      cd.parentNode.insertBefore(overlay, cd);
      overlay.addEventListener('click', close);
      return overlay;
    }

    function closeBtn() {
      return cd.querySelector('.drawer__close-icon') ||
             cd.querySelector('[is="close-button"]') ||
             cd.querySelector('button[is="close-button"]');
    }

    function close() {
      var b = closeBtn();
      if (b) { b.click(); return; }
      // Repli : API native si présente, sinon on retire l'attribut.
      if (typeof cd.hide === 'function') cd.hide();
      else cd.removeAttribute('open');
    }

    function onOpen() {
      makeOverlay();
      // Double rAF pour garantir la transition d'opacité (le voile vient d'être inséré).
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (overlay) overlay.classList.add('is-on');
        });
      });
      document.documentElement.classList.add('pm-drawer-lock');
    }

    function onClosed() {
      if (overlay) overlay.classList.remove('is-on');
      document.documentElement.classList.remove('pm-drawer-lock');
    }

    // Observe l'attribut [open] posé/retiré par le web-component natif.
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName === 'open') {
          if (cd.hasAttribute('open')) onOpen(); else onClosed();
        }
      }
    });
    obs.observe(cd, { attributes: true, attributeFilter: ['open'] });

    // Échap ferme le drawer (si le thème ne le gère pas déjà).
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && cd.hasAttribute('open')) close();
    });

    // État initial (au cas où le drawer serait déjà ouvert au chargement).
    if (cd.hasAttribute('open')) onOpen();
  });
})();
